import React, { useState } from 'react';


export default function OutlinedCard(props) {
  const { name, price, logo, message, address, phone, attach } = props;
  const [open, setOpen] = useState(false);


  return (
    <div className='row mt-5'>
      <div className='proposal--item position-relative'>
        <div className='info'>
          <div className='main'>
            <div
              // className="master--imageContainer lazyload"
              data-bg={logo}
            />
            <img src={logo} style={{ maxHeight: '100px' }} />
            <div className='my-auto p-3'>
              <div className='name'>{name}</div>
              <div className='price'>
                <strong>Price:</strong> {price}
              </div>
            </div>
          </div>
          <div className='item'>
            <div className='header'>Message:</div>
            {!open && <p className='exep-3'>{message}</p>}
            {open && <p>{message}</p>}
          </div>
          {open && (
            <>
              <div className='header'>More Information</div>
              <div className='item'>
                <div className='header'>Email:</div>
                <p>{address}</p>
              </div>
              <div className='item'>
                <div className='header'>phone:</div>
                <p>{phone}</p>
              </div>
              <div className='item'>
                <div className='header'>Image:</div>
                <img
                  src={attach}
                  alt=''
                  className='lazyload mt-3 mb-4'
                  style={{  }}
                />
              </div>
            </>
          )}
        </div>
        <div
          className='load--more'
          onClick={() => {
            setOpen(!open);
          }}
        >
          <div className='btn btn-primary'>
            {!open ? 'Show More' : 'Show Less'}
          </div>
        </div>
      </div>
    </div>
  );
}
